<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="12">
        <van-button block size="small" type="info">从应付账款中获取</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block size="small" type="info">从申请成本外支出类别获取</van-button>
      </van-col>
      <van-col :span="12" class="mt10">
        <van-button block size="small" type="info" @click="apply()">从工资列表中获取</van-button>
      </van-col>
      <van-col :span="12" class="mt10">
        <van-button block size="small" type="info">从应交税金列表获取</van-button>
      </van-col>
    </van-row>
    <van-form class="mt10">
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="付款金额"
        placeholder="请输入金额"
        :rules="[{ required: true }]"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        v-model="formData.Log"
        label="收款单位"
        placeholder="请选择"
        @click="showCollectionCompany = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Date"
        label="付款日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.PayCategory"
        label="资金类别"
        placeholder="请选择"
        @click="showFundCategory = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.DetailRPTypeID"
        label="付款账户"
        placeholder="请选择"
        @click="showPaymentAccount = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Currency"
        label="货币"
        placeholder="请选择"
        @click="showCurrency = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="付款类别"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvTypeDts"
        label="付款子类别"
        placeholder="请选择"
        @click="showPaymentSubType = true"
      />
      <van-field
        input-align="right"
        v-model="formData.BA_GUID"
        label="详细类别"
        placeholder="请输入详细类别"
      />
      <van-field
        input-align="right"
        v-model="formData.Remark"
        rows="4"
        label="摘要/备注"
        type="textarea"
        placeholder="请输入摘要"
      />
    </van-form>
    <van-row :gutter="10" class="mt10">
      <van-col :span="12">
        <van-button block type="info">上传附件</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block type="primary" @click="submitPayment()">提交</van-button>
      </van-col>
    </van-row>
    <!--收款单位弹窗-->
    <van-popup v-model="showCollectionCompany" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.collectionCompany"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showCollectionCompany = false"
      />
    </van-popup>
    <!--付款日期-->
    <van-popup v-model="showPaymentDate" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onShowPaymentDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--资金类别-->
    <van-popup v-model="showFundCategory" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.fundCategory"
        @confirm="onFundCategoryConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--付款账户-->
    <van-popup v-model="showPaymentAccount" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentAccount"
        @confirm="onPaymentAccountConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--货币-->
    <van-popup v-model="showCurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.currency"
        @confirm="onCurrencyConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
    <!--付款类别-->
    <van-popup v-model="showPaymentType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentType"
        @confirm="onPaymentTypeConfirm"
        @cancel="showPaymentType = false"
      />
    </van-popup>
    <!--付款子类别-->
    <van-popup v-model="showPaymentSubType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentSubType"
        @confirm="onPaymentSubTypeConfirm"
        @cancel="showPaymentSubType = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import {
    getPartnersAllFun,
    getBankInfoFun,
    getPayOrReceivablesTypeFun,
    getStreamAccountShipFun,
    createPaymentRecordFun
  } from '@/api/payment'
  import {getCurrencyApi} from "@/api/regist";
  import {Toast} from 'vant'

  export default {
    name: "payment",
    data() {
      return {
        formData: {
          Log_c: '',
          RP_GUID: '',
          Operation: '',
          Remark: '',
          Mark: '',
          Record: '',
          IE_GUID: '',
          InvNo: '',
          BA_GUID: '',//详细类别
          Creator: '',
          SumAmount: '',//付款金额
          Date: '',//付款日期
          PayCategoryID: '',//资金类别ID
          PayCategory: '',//资金类别名称
          Currency: '',//货币
          Log: '',//收款单位
          InvType: '',//付款类别
          InvTypeDts: '',//付款子类别
          DetailRPTypeID: '',//付款账户
          DetailRPType: '',//付款账户
          C_GUID: this.getCookie('CompanyInfo').companyId,//companyId
        },
        showCollectionCompany: false,//收款单位弹窗
        showPaymentDate: false,//付款日期
        showFundCategory: false,//付款账户
        showPaymentAccount: false,//资金类别
        showCurrency: false,//货币
        showPaymentType: false,//付款类别
        showPaymentSubType: false,//付款子类别
        showDetailType: false,//详细类别
        popupData: {
          collectionCompany: [],//收款单位
          fundCategory: [],//资金类别
          paymentAccount: [],//付款账户
          currency: [],//货币
          paymentType: [//付款类别
            {
              text: '经营活动付款',
              value: '经营活动付款'
            },
            {
              text: '投资活动付款',
              value: '投资活动付款'
            },
            {
              text: '筹资活动付款',
              value: '筹资活动付款'
            }
          ],
          paymentSubType: [],//付款子类别
        },
      }
    },
    mounted() {
      this.getCustomer();
      this.getCurrency();
      this.getBankInfo();
      this.getPayOrReceivablesType()
    },
    methods: {
      //收款单位确定按钮
      onCollectionCompanyConfirm(value) {
        this.showCollectionCompany = false;
        this.formData.Log = value.text;
      },
      //付款日期确定按钮
      onShowPaymentDateConfirm(value) {
        this.showPaymentDate = false;
        this.formData.Date = this.moment(value).format('YYYY-MM-DD');
      },
      //资金类别确定按钮
      onFundCategoryConfirm(item) {
        this.showFundCategory = false;
        this.formData.PayCategoryID = item.value;
        this.formData.PayCategory = item.text;
      },
      //付款账户确定按钮
      onPaymentAccountConfirm(item) {
        this.showPaymentAccount = false;
        this.formData.DetailRPTypeID = item.value;
        this.formData.DetailRPType = item.text;
      },
      //货币确定按钮
      onCurrencyConfirm(item) {
        this.showCurrency = false;
        this.formData.Currency = item.value;
      },
      //付款类别确定按钮
      onPaymentTypeConfirm(value) {
        this.showPaymentType = false;
        this.formData.InvType = value.text;
        this.getSubInvType(value.text);
      },
      //付款子类别确定按钮
      onPaymentSubTypeConfirm(item) {
        this.showPaymentSubType = false;
        this.formData.InvTypeDts = item.value;
      },
      async submitPayment() {
        const response = await createPaymentRecordFun(this.formData);
        if (response.success) {
          Toast.success('提交成功');
          this.$router.push({path: "/home"})
        }
      },
      //收款单位
      async getCustomer() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPartnersAllFun(params);
        if (response.success) {
          response.result.map(item => {
            this.popupData.collectionCompany.push({
              text: item.Name,
              value: item.BP_GUID
            })
          });
        }
      },
      //银行账户
      async getBankInfo() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getBankInfoFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.paymentAccount.push({
              text: item.label,
              value: item.value
            })
          })
        }
      },
      //资金类别
      async getPayOrReceivablesType() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPayOrReceivablesTypeFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.fundCategory.push({
              text: item.label,
              value: item.value,
            })
          })
        }
      },
      //货币类型
      async getCurrency() {
        const response = await getCurrencyApi();
        if (response.success) {
          response.result.map(item => {
            this.popupData.currency.push({
              text: item.Code,
              value: item.Code
            })
          });
        }
      },
      //付款子类别
      async getSubInvType(value) {
        const params = {
          streamFlag: 'P'
        };
        const response = await getStreamAccountShipFun(params);
        if (response.success) {
          response.result.map(item => {
            if (item.GroupName === value)
              this.popupData.paymentSubType.push({
                text: item.LASName,
                value: item.LASName
              })
          })
        }
      },
    }
  }
</script>

